import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CourseProgressBarService {
  @Output() progressChange: EventEmitter<any> = new EventEmitter();
}
